/**
 * Подсказки и формат чисел таблицы планов: склады и уходимость размера, дата
 * партии, сумма без копеек. Вынесено из `components/PlansTable.tsx`
 * (нарезка 14.10.26).
 */

import { timeOf } from "@/components/sizeCells";
import { nf } from "@/lib/format";
import type { LineSpeed, LineStock } from "./types";

/**
 * «на складах площадок: WB 4 (снято …) · Ozon 6 (снято …)».
 *
 * Отметки снимков стоят рядом с числами не для красоты: залипший снимок
 * отличается от пустого склада только ими. Время печатает общий `timeOf`, и
 * вместе с ним наследуется известный сдвиг кабинета — обе базы держат UTC без
 * пояса, а `timeOf` читает его как местное. Чинить это надо всем кабинетом
 * сразу, а не одной подсказкой.
 */
export function stockTitle(stock: LineStock): string {
  const часть = (имя: string, qty: number | null, at: string | null) =>
    `${имя} ${qty ?? "—"}${at ? ` (снято ${timeOf(at)})` : ""}`;
  return `на складах площадок: ${часть("WB", stock.wb, stock.wb_at)} · ${часть(
    "Ozon",
    stock.ozon,
    stock.ozon_at,
  )}`;
}

/** Слагаемые уходимости: сложены две площадки, и это должно быть видно. */
export function speedTitle(speed: Record<string, LineSpeed> | null, days: number): string {
  const окно = speed?.[String(days)];
  if (!окно) return "ни одна площадка не знает этот размер";
  return `чистый выкуп за ${days} дней: WB ${окно.wb} · Ozon ${окно.ozon}`;
}

/**
 * Дата режется из строки, а не через `new Date`.
 *
 * `new Date("2026-08-21")` разбирается как ПОЛНОЧЬ UTC, и в часовом поясе с
 * отрицательным сдвигом дата на экране уезжает на день назад. Партия-дата —
 * это день отгрузки фабрике, и сдвигать его нельзя ни на час.
 */
export function fmtDate(iso: string): string {
  const [y = "", m = "", d = ""] = iso.slice(0, 10).split("-");
  return `${d}.${m}.${y.slice(2)}`;
}

/** Сумма приезжает строкой DECIMAL — показываем без копеек, они тут шум. */
export function fmtMoney(value: string): string {
  return nf.format(Math.round(Number(value)));
}
